module.exports = __webpack_public_path__ + "static/media/fileIcon.1e9b20b5.png";